export const CHECKOUT_URL = 'https://dental-instructor-atlas.impultienda.ar/checkout'

export const HERO_IMAGE =
  'https://sb.impultienda.ar/storage/v1/object/public/ebook-images/833d0d56-2379-4fed-8508-df8fc13910a7/product-uploads/mcp_a8f0b163-f547-4d16-a0c2-46c09f6f0074_1793741421666.png'

export const HERO_IMAGE_ALT =
  'Dental Instructor Atlas 6-in-1 box set in teal, white and silver: 6 visual dentistry teaching and clinical training volumes for dental instructors, clinical faculty and dental educators'

export const VISUAL_IMAGE =
  'https://sb.impultienda.ar/storage/v1/object/public/ebook-images/833d0d56-2379-4fed-8508-df8fc13910a7/product-uploads/mcp_476987c6-605b-4cc9-ab7a-5122f6c42a63_1793748664180.jpg'

export const VISUAL_IMAGE_ALT =
  'Dental Instructor Atlas: the 6-volume box set next to a tablet with the six teaching areas, 100% visual material for dental instructors, from beginner to advanced, with immediate access'

export const PRIMARY_CTA = 'GET DENTAL INSTRUCTOR ATLAS NOW!'

export const PRICE_LABEL = '$27 USD'

export interface IncludedItem {
  label: string
  kind: 'included' | 'bonus' | 'extra'
}

export const packageIncludes: IncludedItem[] = [
  { kind: 'included', label: 'Volume 01 — Dental Anatomy, Oral Histology & Tooth Morphology' },
  { kind: 'included', label: 'Volume 02 — Oral Pathology, Dental Radiology & Clinical Diagnosis' },
  { kind: 'included', label: 'Volume 03 — Restorative Dentistry, Dental Materials & Operative Techniques' },
  { kind: 'included', label: 'Volume 04 — Endodontics, Periodontics & Clinical Treatment Procedures' },
  { kind: 'included', label: 'Volume 05 — Oral Surgery, Local Anesthesia & Patient Management' },
  { kind: 'included', label: 'Volume 06 — Dental Clinical Instruction, Teaching Programs & Practical Assessments' },
  { kind: 'bonus', label: 'Dental Anatomy & Tooth Identification Flashcards' },
  { kind: 'bonus', label: 'Clinical Demonstration Lesson Scripts' },
  { kind: 'bonus', label: 'Typodont & Simulation Lab Drills' },
  { kind: 'bonus', label: 'Dental Radiograph Interpretation Practice Cards' },
  { kind: 'bonus', label: 'Clinical Competency Rubrics & Certificates' },
  { kind: 'extra', label: '100% Visual Training System' },
  { kind: 'extra', label: 'Immediate Digital Access' },
  { kind: 'extra', label: 'One-Time Payment' },
]
